<template>
  <div class="home h-screen flex flex-col">
    <video
      id="landing-video"
      src="../assets/landing_video.mp4"
      autoplay
      loop
      playsinline
      muted
    ></video>
    <header>
      <img
        width="100"
        src="data:image/svg+xml;base64,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"
      />
    </header>
    <section class="mb-10">
      <div class="max-w-2xl mx-auto px-5">
        <h1 class="text-4xl md:text-6xl my-8">We create<br /><span class="subtitle">Magic Moments</span></h1>
        <p>
          We are a creative technology studio specialising in interactive brand
          experiences.
        </p>
      </div>
    </section>
    <div class="vl flex-grow"></div>
    <section>
      <nav>
        <ul>
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/location">Location</router-link></li>
          <li><router-link to="/finder">Finder</router-link></li>
          <li><router-link to="/gallery">Gallery</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </nav>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
video {
  object-fit: cover;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
header {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: left;
  align-items: flex-start;
  padding: 1.5rem;
}
h1 {
  color: #fff;
  text-align: center;
}
h1 .subtitle {
  -webkit-text-stroke: 1px;
  -webkit-text-fill-color: rgba(0, 0, 0, 0);
}
p {
  color: #fff;
  font-size: 1.4rem;
  line-height: 1.75rem;
  text-align: center;
}
.vl {
  border-left: 1px solid white;
  margin-left: 50%;
}
nav a {
  text-decoration: none;
  color: #fff;
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border: 1px solid transparent;
  transition: color 0.3s;
  margin: 0;
  font-size: 1.5rem;
}
a:active,
a:hover,
a.router-link-active {
  color: #FE5000;
}
nav {
  width: 90%;
  margin: 1rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

@media only screen and (min-width: 768px) {
  nav ul {
    flex-direction: row;
  }
}

nav li {
  margin: 0 0.5rem;
}
</style>
